import React, { useState, useRef } from "react";
import { Navbar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import logoImage from "../image/favicon.jpg";
import "./css/Navigation-Bar.css";

const NavbarMain = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith("en") ? "en" : "th";
  const changeLanguage = (lng) => i18n.changeLanguage(lng);

  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const hideDropdownTimeout = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false); // เพิ่ม state สำหรับ navigation scroll
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // เพิ่ม state สำหรับ mobile menu

  // เพิ่ม useEffect สำหรับตรวจจับการ scroll และเช็ค pathname
  React.useEffect(() => {
    const isHomePage = window.location.pathname === "/" || window.location.pathname === "/home";
    if (!isHomePage) {
      setIsScrolled(true);
      return;
    }
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 100);
    };
    
    // ปิด mobile menu เมื่อ resize หน้าจอ
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };
    
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // เพิ่ม delay 250ms ก่อนซ่อน dropdown
  const handleServicesMouseEnter = () => {
    if (hideDropdownTimeout.current) {
      clearTimeout(hideDropdownTimeout.current);
      hideDropdownTimeout.current = null;
    }
    setShowServicesDropdown(true);
  };

  const handleServicesMouseLeave = () => {
    hideDropdownTimeout.current = setTimeout(() => {
      setShowServicesDropdown(false);
      setHoveredCategory(null);
    }, 250);
  };

  // เพิ่ม delay 250ms ก่อนซ่อน category dropdown
  const handleCategoryMouseEnter = (category) => {
    if (hideDropdownTimeout.current) {
      clearTimeout(hideDropdownTimeout.current);
      hideDropdownTimeout.current = null;
    }
    setHoveredCategory(category);
  };

  const handleCategoryMouseLeave = () => {
    hideDropdownTimeout.current = setTimeout(() => {
      setHoveredCategory(null);
    }, 250);
  };

  // ฟังก์ชันสำหรับ toggle mobile menu
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // ปิด mobile menu เมื่อคลิกที่ link
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
  <div className="custom-navbar"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      padding: isScrolled ? "10px 20px" : "20px 20px",
      background: isScrolled 
        ? "rgba(255, 255, 255, 0.9)" 
        : "transparent",
      borderBottom: isScrolled 
        ? "1px solid rgba(0, 0, 0, 0.1)" 
        : "none",
      transition: "all 0.5s ease",
      boxShadow: isScrolled 
        ? "0 2px 20px rgba(0, 0, 0, 0.1)" 
        : "none"
    }}
  >
    <div className="nav-left">
      <Navbar.Brand href="/home" className="d-flex align-items-center">
        {/* <img
          src={logoImage}
          alt="Logo"
          width={isScrolled ? "50" : "75"}
          height={isScrolled ? "50" : "75"}
          className="me-2"
          style={{ 
            borderRadius: "50%",
            transition: "all 0.3s ease"
          }}
        /> */}
        <span
          className="fw-bold"
          style={{ 
            fontFamily: "Prompt, sans-serif",
            fontSize: isScrolled ? "1.1rem" : "1.5rem", // ปรับขนาดตาม scroll
            color: isScrolled ? " #1e293b" : "rgb(0, 0, 0)",
            transition: "all 0.3s ease",
            whiteSpace: "nowrap" // ป้องกันชื่อขึ้นบรรทัดใหม่
          }}
        >
          &nbsp;&nbsp;{t("navbar.brand")}
        </span>
      </Navbar.Brand>
    </div>
    
    {/* Mobile Menu Button */}
    <div className="mobile-menu-btn" style={{ display: "none" }}>
      <button
        onClick={toggleMobileMenu}
        style={{
          background: "none",
          border: "none",
          fontSize: "1.5rem",
          color: isScrolled ? "#1e293b" : "rgb(0, 0, 0)",
          cursor: "pointer",
          padding: "8px",
          borderRadius: "6px",
          transition: "all 0.3s ease"
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = "rgba(59, 130, 246, 0.1)";
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = "transparent";
        }}
      >
        {isMobileMenuOpen ? "✕" : "☰"}
      </button>
    </div>
    
    <div className="nav-right">
      <a href="/home" style={{ textDecoration: "none" }}>
        <span 
          className="nav-item"
          style={{
            color: isScrolled ? " #1e293b" : "rgb(0, 0, 0)",
            fontSize: isScrolled ? "1.1rem" : "1.4rem",
            transition: "all 0.3s ease",
          }}
        >
          {t("navbar.home")}
        </span>
      </a>
      <div className="divider" style={{
        backgroundColor: isScrolled ? "rgb(115, 118, 122)" : "rgba(0, 0, 0, 0.5)",
        transition: "all 0.3s ease"
      }} />
      <a href="/home#getstart" style={{ textDecoration: "none" }}>
        <span
          className="nav-item"
          style={{
            color: isScrolled ? " #1e293b" : "rgb(0, 0, 0)",
            fontSize: isScrolled ? "1.1rem" : "1.4rem",
            transition: "all 0.3s ease",
          }}
        >
          {t("navbar.about")}
        </span>
      </a>
      <div className="divider" style={{
        backgroundColor: isScrolled ? "rgb(115, 118, 122)" : "rgba(0, 0, 0, 0.5)",
        transition: "all 0.3s ease"
      }} />
      
      <div 
        className="services-dropdown-container"
        onMouseEnter={handleServicesMouseEnter}
        onMouseLeave={handleServicesMouseLeave}
        style={{ position: "relative", display: "inline-block" }}
      >
        <a href="/home#our-services" style={{ textDecoration: "none" }}>
          <span 
            className="nav-item"
            style={{
              color: isScrolled ? " #1e293b" : "rgb(0, 0, 0)",
              fontSize: isScrolled ? "1.1rem" : "1.4rem",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}
          >
            {t("navbar.services")}
            <span
              style={{
                display: "inline-block",
                transition: "transform 0.3s",
                transform: showServicesDropdown ? "rotate(135deg)" : "none",
                fontSize: "24px",
                color: showServicesDropdown ? "#f63b3bff" : "#8b6464ff",
                fontWeight: "300"
              }}
            >
              +
            </span>
          </span>
        </a>
        
        {showServicesDropdown && (
          <div
            className="services-dropdown"
            style={{
              position: "absolute",
              top: "100%",
              right: "-50px",
              minWidth: "320px",
              borderRadius: "16px",
              zIndex: 1001,
              border: "1px solid rgba(0, 0, 0, 0.08)",
              marginTop: "12px",
              background: isScrolled
                ? "rgba(255,255,255,1)"
                : "rgba(255,255,255,0.5)",
              backdropFilter: isScrolled ? "blur(50px)" : "blur(50px)",
              boxShadow: isScrolled
                ? "0 2px 20px rgba(0,0,0,0.1)"
                : "0 4px 24px rgba(0,0,0,0.08)",
              transition: "all 0.3s ease"
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              onMouseEnter={handleServicesMouseEnter}
              onMouseLeave={handleServicesMouseLeave}
            >
              <div
                onMouseEnter={() => handleCategoryMouseEnter('legal')}
                onMouseLeave={handleCategoryMouseLeave}
                style={{ position: "relative" }}
              >
                <a href="/services" style={{ textDecoration: "none" }}>
                  <div style={{ 
                    padding: "16px 20px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    backgroundColor: hoveredCategory === 'legal' ? "rgba(59, 130, 246, 0.08)" : "transparent",
                    transition: "all 0.3s ease",
                    boxShadow: hoveredCategory === 'legal' ? "0 4px 12px rgba(59, 130, 246, 0.15)" : "none"
                  }}>
                    <span style={{ 
                      color: "#1e293b", 
                      fontWeight: "600", 
                      fontSize: "15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between"
                    }}>
                      {t("serviceCategories.legal.title")}
                      <span style={{ fontSize: "12px", color: "#64748b" }}>→</span>
                    </span>
                  </div>
                </a>
                {hoveredCategory === 'legal' && (
                  <div
                    onMouseEnter={() => handleCategoryMouseEnter('legal')}
                    onMouseLeave={handleCategoryMouseLeave}
                    style={{
                      position: "absolute",
                      right: "100%",
                      top: "0",
                      minWidth: "380px",
                      boxShadow: isScrolled
                        ? "0 2px 20px rgba(0,0,0,0.1)"
                        : "0 4px 24px rgba(0,0,0,0.08)",
                      borderRadius: "16px",
                      padding: "20px",
                      zIndex: 1002,
                      border: "1px solid rgba(0, 0, 0, 0.08)",
                      marginRight: "0px",
                      background: isScrolled
                        ? "rgba(255,255,255,1)"
                        : "rgba(255,255,255,0.98)",
                      backdropFilter: "blur(50px)",
                    }}
                  >
                    <h6 style={{ 
                      color: "#1e293b", 
                      fontWeight: "700", 
                      marginBottom: "16px",
                      fontSize: "16px",
                      borderBottom: "3px solid #3b82f6",
                      paddingBottom: "10px",
                      background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent"
                    }}>
                      {t("serviceCategories.legal.title")}
                    </h6>
                    <ul style={{ 
                      listStyle: "none", 
                      padding: 0, 
                      margin: 0,
                      fontSize: "14px",
                      lineHeight: "1.6"
                    }}>
                      <a href="/services/business-law" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                      <li style={{ 
                        marginBottom: "10px", 
                        color: "#64748b", 
                        cursor: "pointer", 
                        padding: "8px 12px", 
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        borderLeft: "3px solid transparent"
                      }} 
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f1f5f9";
                            e.target.style.borderLeftColor = "#3b82f6";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                        
                          • {t("serviceCategories.legal.items.businessLaw")}
                        
                      </li>
                      </a>
                      <a href="/services/tax-law" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                      <li style={{ 
                        marginBottom: "10px", 
                        color: "#64748b", 
                        cursor: "pointer", 
                        padding: "8px 12px", 
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        borderLeft: "3px solid transparent"
                      }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f1f5f9";
                            e.target.style.borderLeftColor = "#3b82f6";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                        • {t("serviceCategories.legal.items.taxLaw")}
                      </li>
                      </a>
                      <a href="/services/litigation" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                      <li style={{ 
                        marginBottom: "10px", 
                        color: "#64748b", 
                        cursor: "pointer", 
                        padding: "8px 12px", 
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        borderLeft: "3px solid transparent"
                      }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f1f5f9";
                            e.target.style.borderLeftColor = "#3b82f6";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                        • {t("serviceCategories.legal.items.litigation")}
                      </li>
                      </a>
                      <a href="/services/other-law" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                      <li style={{ 
                        marginBottom: "10px", 
                        color: "#64748b", 
                        cursor: "pointer", 
                        padding: "8px 12px", 
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        borderLeft: "3px solid transparent"
                      }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f1f5f9";
                            e.target.style.borderLeftColor = "#3b82f6";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                        • {t("serviceCategories.legal.items.otherLaw")}
                      </li>
                      </a>
                      <a href="/services/transfer-pricing" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                      <li style={{ 
                        marginBottom: "10px", 
                        color: "#64748b", 
                        cursor: "pointer", 
                        padding: "8px 12px", 
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        borderLeft: "3px solid transparent"
                      }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f1f5f9";
                            e.target.style.borderLeftColor = "#3b82f6";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                        • {t("serviceCategories.legal.items.transferPricing")}
                      </li>
                      </a>
                      <a href="/services/testament" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                      <li style={{ 
                        marginBottom: "10px", 
                        color: "#64748b", 
                        cursor: "pointer", 
                        padding: "8px 12px", 
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        borderLeft: "3px solid transparent"
                      }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f1f5f9";
                            e.target.style.borderLeftColor = "#3b82f6";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                        • {t("serviceCategories.legal.items.testament")}
                      </li>
                      </a>
                      <a href="/services/civil-litigation" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                      <li style={{ 
                        marginBottom: "10px", 
                        color: "#64748b", 
                        cursor: "pointer", 
                        padding: "8px 12px", 
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        borderLeft: "3px solid transparent"
                      }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f1f5f9";
                            e.target.style.borderLeftColor = "#3b82f6";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                        • {t("serviceCategories.legal.items.civilLitigation")}
                      </li>
                      </a>
                      <a href="/services/divorce" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                      <li style={{ 
                        marginBottom: "10px", 
                        color: "#64748b", 
                        cursor: "pointer", 
                        padding: "8px 12px", 
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        borderLeft: "3px solid transparent"
                      }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f1f5f9";
                            e.target.style.borderLeftColor = "#3b82f6";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                        • {t("serviceCategories.legal.items.divorce")}
                      </li>
                      </a>
                    </ul>
                  </div>
                )}
              </div>

              <div
                onMouseEnter={() => handleCategoryMouseEnter('accounting')}
                onMouseLeave={handleCategoryMouseLeave}
                style={{ position: "relative" }}
              >
                <a href="/services" style={{ textDecoration: "none" }}>
                  <div style={{ 
                    padding: "16px 20px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    backgroundColor: hoveredCategory === 'accounting' ? "rgba(16, 185, 129, 0.08)" : "transparent",
                    transition: "all 0.3s ease",
                    boxShadow: hoveredCategory === 'accounting' ? "0 4px 12px rgba(16, 185, 129, 0.15)" : "none"
                  }}>
                    <span style={{ 
                      color: "#1e293b", 
                      fontWeight: "600", 
                      fontSize: "15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between"
                    }}>
                      {t("serviceCategories.accounting.title")}
                      <span style={{ fontSize: "12px", color: "#64748b" }}>→</span>
                    </span>
                  </div>
                </a>
                {hoveredCategory === 'accounting' && (
                  <div
                    onMouseEnter={() => handleCategoryMouseEnter('accounting')}
                    onMouseLeave={handleCategoryMouseLeave}
                    style={{
                      position: "absolute",
                      right: "100%",
                      top: "0",
                      minWidth: "320px",
                      boxShadow: isScrolled
                        ? "0 2px 20px rgba(0,0,0,0.1)"
                        : "0 4px 24px rgba(0,0,0,0.08)",
                      borderRadius: "16px",
                      padding: "20px",
                      zIndex: 1002,
                      border: "1px solid rgba(0, 0, 0, 0.08)",
                      marginRight: "0px",
                      background: isScrolled
                        ? "rgba(255,255,255,1)"
                        : "rgba(255,255,255,0.98)",
                      backdropFilter: isScrolled ? "blur(50px)" : "blur(20px)",
                      transition: "all 0.3s ease"
                    }}
                  >
                    <h6 style={{ 
                      color: "#1e293b", 
                      fontWeight: "700", 
                      marginBottom: "16px",
                      fontSize: "16px",
                      borderBottom: "3px solid #10b981",
                      paddingBottom: "10px",
                      background: "linear-gradient(135deg, #10b981, #059669)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent"
                    }}>
                      {t("serviceCategories.accounting.title")}
                    </h6>
                    <ul style={{ 
                      listStyle: "none", 
                      padding: 0, 
                      margin: 0,
                      fontSize: "14px",
                      lineHeight: "1.6"
                    }}>
                      <a href="/services/accounting" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                      <li style={{ 
                        marginBottom: "10px", 
                        color: "#64748b", 
                        cursor: "pointer", 
                        padding: "8px 12px", 
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        borderLeft: "3px solid transparent"
                      }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f0fdf4";
                            e.target.style.borderLeftColor = "#10b981";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                        • {t("serviceCategories.accounting.items.accounting")}
                      </li>
                      </a>
                      <a href="/services/payroll" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                      <li style={{ 
                        marginBottom: "10px", 
                        color: "#64748b", 
                        cursor: "pointer", 
                        padding: "8px 12px", 
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        borderLeft: "3px solid transparent"
                      }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#f0fdf4";
                            e.target.style.borderLeftColor = "#10b981";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                        • {t("serviceCategories.accounting.items.payroll")}
                      </li>
                      </a>
                    </ul>
                  </div>
                )}
              </div>

              <div
                onMouseEnter={() => handleCategoryMouseEnter('audit')}
                onMouseLeave={handleCategoryMouseLeave}
                style={{ position: "relative" }}
              >
                <a href="/services/audit" style={{ textDecoration: "none" }}>
                  <div style={{ 
                    padding: "16px 20px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    backgroundColor: hoveredCategory === 'audit' ? "rgba(245, 158, 11, 0.08)" : "transparent",
                    transition: "all 0.3s ease",
                    boxShadow: hoveredCategory === 'audit' ? "0 4px 12px rgba(245, 158, 11, 0.15)" : "none"
                  }}>
                    <span style={{ 
                      color: "#1e293b", 
                      fontWeight: "600", 
                      fontSize: "15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between"
                    }}>
                      {t("serviceCategories.audit.title")}
                      <span style={{ fontSize: "12px", color: "#64748b" }}>→</span>
                    </span>
                  </div>
                </a>
                {hoveredCategory === 'audit' && (
                  <div
                    onMouseEnter={() => handleCategoryMouseEnter('audit')}
                    onMouseLeave={handleCategoryMouseLeave}
                    style={{
                      position: "absolute",
                      right: "100%",
                      top: "0",
                      minWidth: "420px",
                      boxShadow: isScrolled
                        ? "0 2px 20px rgba(0,0,0,0.1)"
                        : "0 4px 24px rgba(0,0,0,0.08)",
                      borderRadius: "16px",
                      padding: "20px",
                      zIndex: 1002,
                      border: "1px solid rgba(0, 0, 0, 0.08)",
                      marginRight: "0px",
                      background: isScrolled
                        ? "rgba(255,255,255,1)"
                        : "rgba(255,255,255,0.98)",
                      backdropFilter: isScrolled ? "blur(50px)" : "blur(20px)",
                      transition: "all 0.3s ease"
                    }}
                  >
                    <h6 style={{ 
                      color: "#1e293b", 
                      fontWeight: "700", 
                      marginBottom: "16px",
                      fontSize: "16px",
                      borderBottom: "3px solid #f59e0b",
                      paddingBottom: "10px",
                      background: "linear-gradient(135deg, #f59e0b, #d97706)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent"
                    }}>
                      {t("serviceCategories.audit.title")}
                    </h6>
                    <ul style={{ 
                      listStyle: "none", 
                      padding: 0, 
                      margin: 0,
                      fontSize: "14px",
                      lineHeight: "1.6"
                    }}>
                      <a href="/services/statement-audit" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "10px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "8px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#fffbeb";
                            e.target.style.borderLeftColor = "#f59e0b";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                          • {t("serviceCategories.audit.items.statementAudit")}
                        </li>
                      </a>
                      <a href="/services/statement-review" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "10px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "8px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#fffbeb";
                            e.target.style.borderLeftColor = "#f59e0b";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                          • {t("serviceCategories.audit.items.statementReview")}
                        </li>
                      </a>
                      <a href="/services/due-diligence" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "10px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "8px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#fffbeb";
                            e.target.style.borderLeftColor = "#f59e0b";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                          • {t("serviceCategories.audit.items.dueDiligence")}
                        </li>
                      </a>
                      <a href="/services/special-audit" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "10px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "8px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#fffbeb";
                            e.target.style.borderLeftColor = "#f59e0b";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                          • {t("serviceCategories.audit.items.specialAudit")}
                        </li>
                      </a>
                      <a href="/services/accounting-advisory" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "10px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "8px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#fffbeb";
                            e.target.style.borderLeftColor = "#f59e0b";
                            e.target.style.color = "#1e293b";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.borderLeftColor = "transparent";
                            e.target.style.color = "#64748b";
                          }}>
                          • {t("serviceCategories.audit.items.accountingAdvisory")}
                        </li>
                      </a>
                    </ul>
                  </div>
                )}
              </div>

              <div
                onMouseEnter={() => handleCategoryMouseEnter('internal')}
                onMouseLeave={handleCategoryMouseLeave}
                style={{ position: "relative" }}
              >
                <a href="/services/internal-audit" style={{ textDecoration: "none" }}>
                  <div style={{ 
                    padding: "16px 20px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    backgroundColor: hoveredCategory === 'internal' ? "rgba(139, 92, 246, 0.08)" : "transparent",
                    transition: "all 0.3s ease",
                    boxShadow: hoveredCategory === 'internal' ? "0 4px 12px rgba(139, 92, 246, 0.15)" : "none"
                  }}>
                    <span style={{ 
                      color: "#1e293b", 
                      fontWeight: "600", 
                      fontSize: "15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between"
                    }}>
                      {t("serviceCategories.internalAudit.title")}
                      <span style={{ fontSize: "12px", color: "#64748b" }}>→</span>
                    </span>
                  </div>
                </a>
                {hoveredCategory === 'internal' && (
                  <div
                    onMouseEnter={() => handleCategoryMouseEnter('internal')}
                    onMouseLeave={handleCategoryMouseLeave}
                    style={{
                      position: "absolute",
                      right: "100%",
                      top: "0",
                      minWidth: "480px",
                      boxShadow: isScrolled
                        ? "0 2px 20px rgba(0,0,0,0.1)"
                        : "0 4px 24px rgba(0,0,0,0.08)",
                      borderRadius: "16px",
                      padding: "20px",
                      zIndex: 1002,
                      border: "1px solid rgba(0, 0, 0, 0.08)",
                      marginRight: "0px",
                      background: isScrolled
                        ? "rgba(255,255,255,1)"
                        : "rgba(255,255,255,0.98)",
                      backdropFilter: isScrolled ? "blur(50px)" : "blur(20px)",
                      transition: "all 0.3s ease"
                    }}
                  >
                    <h6 style={{ 
                      color: "#1e293b", 
                      fontWeight: "700", 
                      marginBottom: "16px",
                      fontSize: "16px",
                      borderBottom: "3px solid #8b5cf6",
                      paddingBottom: "10px",
                      background: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent"
                    }}>
                      {t("serviceCategories.internalAudit.title")}
                    </h6>
                    <ul style={{ 
                      listStyle: "none", 
                      padding: 0, 
                      margin: 0,
                      fontSize: "14px",
                      lineHeight: "1.6",
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "0 24px"
                      // maxHeight: "300px",
                      // overflowY: "auto"
                    }}>
                      <a href="/services/internal-audit" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.ia")}
                        </li>
                      </a>
                      <a href="/services/ipo" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.ipo")}
                        </li>
                      </a>
                      <a href="/services/cac" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.cac")}
                        </li>
                      </a>
                      <a href="/services/qar" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.qar")}
                        </li>
                      </a>
                      <a href="/services/it-audit" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.itAudit")}
                        </li>
                      </a>
                      <a href="/services/system-development" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.systemDevelopment")}
                        </li>
                      </a>
                      <a href="/services/business-development" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.businessDevelopment")}
                        </li>
                      </a>
                      <a href="/services/special-investigation" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.specialInvestigation")}
                        </li>
                      </a>
                      <a href="/services/esg-reporting" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.esgReporting")}
                        </li>
                      </a>
                      <a href="/services/due-diligence" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.dueDiligence")}
                        </li>
                      </a>
                      <a href="/services/carbon-footprint" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.carbonFootprint")}
                        </li>
                      </a>
                      <a href="/services/in-house" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.inHouse")}
                        </li>
                      </a>
                      <a href="/services/ai-governance" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.aiGovernance")}
                        </li>
                      </a>
                      <a href="/services/ai-gra" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "8px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "6px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#faf5ff";
                              e.target.style.borderLeftColor = "#8b5cf6";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.internalAudit.items.aiGra")}
                        </li>
                      </a>
                    </ul>
                  </div>
                )}
              </div>

              <div
                onMouseEnter={() => handleCategoryMouseEnter('it')}
                onMouseLeave={handleCategoryMouseLeave}
                style={{ position: "relative" }}
              >
                <a href="/services/web-it" style={{ textDecoration: "none" }}>
                  <div style={{ 
                    padding: "16px 20px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    backgroundColor: hoveredCategory === 'it' ? "rgba(239, 68, 68, 0.08)" : "transparent",
                    transition: "all 0.3s ease",
                    boxShadow: hoveredCategory === 'it' ? "0 4px 12px rgba(239, 68, 68, 0.15)" : "none"
                  }}>
                    <span style={{ 
                      color: "#1e293b", 
                      fontWeight: "600", 
                      fontSize: "15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between"
                    }}>
                      {t("serviceCategories.websiteIt.title")}
                      <span style={{ fontSize: "12px", color: "#64748b" }}>→</span>
                    </span>
                  </div>
                </a>
                {hoveredCategory === 'it' && (
                  <div
                    onMouseEnter={() => handleCategoryMouseEnter('it')}
                    onMouseLeave={handleCategoryMouseLeave}
                    style={{
                      position: "absolute",
                      right: "100%",
                      top: "0",
                      minWidth: "480px",
                      boxShadow: isScrolled
                        ? "0 2px 20px rgba(0,0,0,0.1)"
                        : "0 4px 24px rgba(0,0,0,0.08)",
                      borderRadius: "16px",
                      padding: "20px",
                      zIndex: 1002,
                      border: "1px solid rgba(0, 0, 0, 0.08)",
                      marginRight: "0px",
                      background: isScrolled
                        ? "rgba(255,255,255,1)"
                        : "rgba(255,255,255,0.98)",
                      backdropFilter: isScrolled ? "blur(50px)" : "blur(20px)",
                      transition: "all 0.3s ease"
                    }}
                  >
                    <h6 style={{ 
                      color: "#1e293b", 
                      fontWeight: "700", 
                      marginBottom: "16px",
                      fontSize: "16px",
                      borderBottom: "3px solid #ef4444",
                      paddingBottom: "10px",
                      background: "linear-gradient(135deg, #ef4444, #dc2626)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent"
                    }}>
                      {t("serviceCategories.websiteIt.title")}
                    </h6>
                    <ul style={{ 
                      listStyle: "none", 
                      padding: 0, 
                      margin: 0,
                      fontSize: "14px",
                      lineHeight: "1.6"
                    }}>
                      <a href="/services/web-service" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "10px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "8px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#fef2f2";
                              e.target.style.borderLeftColor = "#ef4444";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.websiteIt.items.webService")}
                        </li>
                      </a>
                      <a href="/services/web-hosting" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "10px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "8px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#fef2f2";
                              e.target.style.borderLeftColor = "#ef4444";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.websiteIt.items.webHosting")}
                        </li>
                      </a>
                      <a href="/services/web-maintenance" style={{ color: "inherit", textDecoration: "none", display: "block" }}>
                        <li style={{ 
                          marginBottom: "10px", 
                          color: "#64748b", 
                          cursor: "pointer", 
                          padding: "8px 12px", 
                          borderRadius: "8px",
                          transition: "all 0.2s ease",
                          borderLeft: "3px solid transparent"
                        }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#fef2f2";
                              e.target.style.borderLeftColor = "#ef4444";
                              e.target.style.color = "#1e293b";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.borderLeftColor = "transparent";
                              e.target.style.color = "#64748b";
                            }}>
                          • {t("serviceCategories.websiteIt.items.webMaintenance")}
                        </li>
                      </a>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      
      <div className="divider" style={{
        backgroundColor: isScrolled ? " rgb(115, 118, 122)" : "rgba(0, 0, 0, 0.5)",
        transition: "all 0.3s ease"
      }} />
      <a href="/careers" style={{ textDecoration: "none" }}>
        <span 
          className="nav-item"
          style={{
            color: isScrolled ? " #1e293b" : "rgb(0, 0, 0)",
            fontSize: isScrolled ? "1.1rem" : "1.4rem",
            transition: "all 0.3s ease",
          }}
        >
          {t("navbar.career")}
        </span>
      </a>
      <div className="divider" style={{
        backgroundColor: isScrolled ? "rgb(115, 118, 122)" : "rgba(0, 0, 0, 0.5)",
        transition: "all 0.3s ease"
      }} />
      <a href="/home#contact" style={{ textDecoration: "none" }}>
        <span
          className="nav-item"
          style={{
            color: isScrolled ? " #1e293b" : "rgb(0, 0, 0)",
            fontSize: isScrolled ? "1.1rem" : "1.4rem",
            transition: "all 0.3s ease",
          }}
        >
          {t("navbar.contact")}
        </span>
      </a>

      <div className="divider" style={{
        backgroundColor: isScrolled ? "rgb(115, 118, 122)" : "rgba(0, 0, 0, 0.5)",
        transition: "all 0.3s ease"
      }} />

      <div className="lang-switcher" style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        marginLeft: "8px",
        padding: "4px",
        borderRadius: "20px",
        background: isScrolled ? "rgba(0,0,0,0.05)" : "rgba(255,255,255,0.25)",
        backdropFilter: "blur(8px)",
        border: "1px solid rgba(0,0,0,0.08)",
        transition: "all 0.3s ease"
      }}>
        <button
          onClick={() => changeLanguage("th")}
          aria-label="ภาษาไทย"
          style={{
            border: "none",
            outline: "none",
            cursor: "pointer",
            padding: "4px 12px",
            borderRadius: "16px",
            fontSize: "0.85rem",
            fontWeight: 600,
            color: currentLang === "th" ? "#ffffff" : (isScrolled ? "#1e293b" : "#1e293b"),
            background: currentLang === "th" ? "#3b82f6" : "transparent",
            transition: "all 0.25s ease"
          }}
        >
          TH
        </button>
        <button
          onClick={() => changeLanguage("en")}
          aria-label="English"
          style={{
            border: "none",
            outline: "none",
            cursor: "pointer",
            padding: "4px 12px",
            borderRadius: "16px",
            fontSize: "0.85rem",
            fontWeight: 600,
            color: currentLang === "en" ? "#ffffff" : (isScrolled ? "#1e293b" : "#1e293b"),
            background: currentLang === "en" ? "#3b82f6" : "transparent",
            transition: "all 0.25s ease"
          }}
        >
          EN
        </button>
      </div>

    </div>

    {/* Mobile Menu Backdrop */}
    {isMobileMenuOpen && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0, 0, 0, 0.3)",
          zIndex: 998,
          opacity: isMobileMenuOpen ? 1 : 0,
          transition: "opacity 0.3s ease"
        }}
        onClick={closeMobileMenu}
      />
    )}

    {/* Mobile Menu */}
    <div 
      className="mobile-menu"
      style={{
        display: "none",
        position: "fixed",
        top: isScrolled ? "80px" : "115px",
        left: 0,
        right: 0,
        background: "rgba(255, 255, 255, 0)",
        borderRadius: "16px",
        backdropFilter: "blur(20px)", // <<--- fix blur for mobile
        borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        zIndex: 999,
        padding: "25px 0px",
        transform: isMobileMenuOpen ? "translateY(0)" : "translateY(-100%)",
        opacity: isMobileMenuOpen ? 1 : 0,
        visibility: isMobileMenuOpen ? "visible" : "hidden",
        transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        maxHeight: "calc(100vh - 115px)",
        overflowY: "auto"
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <a href="/home" onClick={closeMobileMenu} style={{ textDecoration: "none" }}>
          <div style={{
            color: "#1e293b",
            fontSize: "1.1rem",
            fontWeight: "500",
            padding: "15px 20px",
            borderRadius: "12px",
            border: "1px solid rgba(0, 0, 0, 0.05)",
            background: "rgba(255, 255, 255, 0.8)",
            transition: "all 0.3s ease",
            cursor: "pointer"
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "rgba(59, 130, 246, 0.1)";
            e.target.style.borderColor = "#3b82f6";
            e.target.style.transform = "translateX(5px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "rgba(255, 255, 255, 0.8)";
            e.target.style.borderColor = "rgba(0, 0, 0, 0.05)";
            e.target.style.transform = "translateX(0)";
          }}>
            🏠 {t("navbar.home")}
          </div>
        </a>
        
        <a href="/home#getstart" onClick={closeMobileMenu} style={{ textDecoration: "none" }}>
          <div style={{
            color: "#1e293b",
            fontSize: "1.1rem",
            fontWeight: "500",
            padding: "15px 20px",
            borderRadius: "12px",
            border: "1px solid rgba(0, 0, 0, 0.05)",
            background: "rgba(255, 255, 255, 0.8)",
            transition: "all 0.3s ease",
            cursor: "pointer"
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "rgba(59, 130, 246, 0.1)";
            e.target.style.borderColor = "#3b82f6";
            e.target.style.transform = "translateX(5px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "rgba(255, 255, 255, 0.8)";
            e.target.style.borderColor = "rgba(0, 0, 0, 0.05)";
            e.target.style.transform = "translateX(0)";
          }}>
            ℹ️ {t("navbar.about")}
          </div>
        </a>
        



        <a href="#our-services" onClick={closeMobileMenu} style={{ textDecoration: "none" }}>
          <div style={{
            color: "#1e293b",
            fontSize: "1.1rem",
            fontWeight: "500",
            padding: "15px 20px",
            borderRadius: "12px",
            border: "1px solid rgba(0, 0, 0, 0.05)",
            background: "rgba(255, 255, 255, 0.8)",
            transition: "all 0.3s ease",
            cursor: "pointer"
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "rgba(59, 130, 246, 0.1)";
            e.target.style.borderColor = "#3b82f6";
            e.target.style.transform = "translateX(5px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "rgba(255, 255, 255, 0.8)";
            e.target.style.borderColor = "rgba(0, 0, 0, 0.05)";
            e.target.style.transform = "translateX(0)";
          }}>
            📜 {t("navbar.services")}
          </div>
        </a>

        
        <a href="/careers" onClick={closeMobileMenu} style={{ textDecoration: "none" }}>
          <div style={{
            color: "#1e293b",
            fontSize: "1.1rem",
            fontWeight: "500",
            padding: "15px 20px",
            borderRadius: "12px",
            border: "1px solid rgba(0, 0, 0, 0.05)",
            background: "rgba(255, 255, 255, 0.8)",
            transition: "all 0.3s ease",
            cursor: "pointer"
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "rgba(59, 130, 246, 0.1)";
            e.target.style.borderColor = "#3b82f6";
            e.target.style.transform = "translateX(5px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "rgba(255, 255, 255, 0.8)";
            e.target.style.borderColor = "rgba(0, 0, 0, 0.05)";
            e.target.style.transform = "translateX(0)";
          }}>
            🎓 {t("navbar.career")}
          </div>
        </a>
        
        <a href="/home#contact" onClick={closeMobileMenu} style={{ textDecoration: "none" }}>
          <div style={{
            color: "#1e293b",
            fontSize: "1.1rem",
            fontWeight: "500",
            padding: "15px 20px",
            borderRadius: "12px",
            border: "1px solid rgba(0, 0, 0, 0.05)",
            background: "rgba(255, 255, 255, 0.8)",
            transition: "all 0.3s ease",
            cursor: "pointer"
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "rgba(59, 130, 246, 0.1)";
            e.target.style.borderColor = "#3b82f6";
            e.target.style.transform = "translateX(5px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "rgba(255, 255, 255, 0.8)";
            e.target.style.borderColor = "rgba(0, 0, 0, 0.05)";
            e.target.style.transform = "translateX(0)";
          }}>
            📞 {t("navbar.contact")}
          </div>
        </a>

        <div style={{
          display: "flex",
          justifyContent: "center",
          gap: "8px",
          padding: "12px",
          marginTop: "8px"
        }}>
          <button
            onClick={() => { changeLanguage("th"); closeMobileMenu(); }}
            style={{
              padding: "8px 24px",
              borderRadius: "20px",
              border: "1px solid rgba(0,0,0,0.1)",
              background: currentLang === "th" ? "#3b82f6" : "#ffffff",
              color: currentLang === "th" ? "#ffffff" : "#1e293b",
              fontWeight: 600,
              cursor: "pointer",
              fontSize: "0.95rem"
            }}
          >
            TH
          </button>
          <button
            onClick={() => { changeLanguage("en"); closeMobileMenu(); }}
            style={{
              padding: "8px 24px",
              borderRadius: "20px",
              border: "1px solid rgba(0,0,0,0.1)",
              background: currentLang === "en" ? "#3b82f6" : "#ffffff",
              color: currentLang === "en" ? "#ffffff" : "#1e293b",
              fontWeight: 600,
              cursor: "pointer",
              fontSize: "0.95rem"
            }}
          >
            EN
          </button>
        </div>
      </div>
    </div>
  </div>
  );
};

export default NavbarMain;
